module.exports = __webpack_public_path__ + "static/media/elyakada_logo.7972e179.png";